// industryCategories.js
const nationalStandardIndustryCategories = [
    "农、林、牧、渔业",
    "采矿业",
    "制造业",
    "电力、热力、燃气及水生产和供应业",
    "建筑业",
    "批发和零售业",
    "交通运输、仓储和邮政业",
    "住宿和餐饮业",
    "信息传输、软件和信息技术服务业",
    "金融业",
    "房地产业",
    "租赁和商务服务业",
    "科学研究和技术服务业",
    "水利、环境和公共设施管理业",
    "居民服务、修理和其他服务业",
    "教育",
    "卫生和社会工作",
    "文化、体育和娱乐业",
    "公共管理、社会保障和社会组织",
    "国际组织"
];

// 导出数组
export default nationalStandardIndustryCategories;
